import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ISessionTemplateFollowUpTask } from "../../utils/types/models";

export default createEntityReducer<ISessionTemplateFollowUpTask>(Endpoint.SessionTemplateFollowUpTasks, Endpoint.SessionTemplateFollowUpTasksList);
